import React, { memo, useEffect, useState } from 'react';
import { Row } from 'react-bootstrap';
import moment from 'moment';
import { isLoggedIn } from '../../../services/AuthService';
import './Footer.scss';
import LOGO from '../../../assets/images/copic_reverse.svg';

/**
 * @component Footer
 * @description Render footer with copyright text and related links
 */
const Footer: React.FunctionComponent = () => {
  const curentYear = moment(new Date()).format('YYYY');
  const [loggedIn, setUserLoggedIn] = useState<undefined | boolean>(undefined);

  useEffect(() => {
    setUserLoggedIn(isLoggedIn());
  }, [loggedIn]);

  return (
    <footer className='footer mb-md-2 md-lg-5 mt-md-2'>
      <Row className='justify-content-between'>
        <ul className='horzi'>
          <div className='logo-link'>
            <img src={LOGO} alt='logo' className='footer-logo' />
          </div>
        </ul>
      </Row>
      <Row className='justify-content-between'>
        <nav className='footer-legal'>
          <ul className='horzi'>
            <li>© {curentYear} COPIC Insurance Company</li>
          </ul>
          <ul className='horzi'>
            <li>
              <a href='http://callcopic.com/privacy-policy' target='_blank' rel='noreferrer'>
                Privacy Policy
              </a>
            </li>
            <li>
              <a href='http://callcopic.com/terms-of-use' target='_blank' rel='noreferrer'>
                Terms of Use
              </a>
            </li>
            <li>
              <a href='http://callcopic.com/contact-copic' target='_blank' rel='noreferrer'>
                Contact Us
              </a>
            </li>
            <li>
              <a href='tel:800-421-1834'>800.421.1834</a>
            </li>
          </ul>
        </nav>
      </Row>
    </footer>
  );
};

export default memo(Footer);
